<template>
  <v-app id="bg">
    <side-bar />

    <v-main>
      <v-container fluid>
        <section id="overview">
          <overview :games="games"></overview>
        </section>

        <section id="features">
          <v-row style="margin: 20px 0px 75px">
            <v-col class="text-center">
              <span class="h3">Good Game Features</span>
            </v-col>
          </v-row>

          <v-row justify="center">
            <template v-for="(item, index) in features" v-bind="index">
              <feature-card :key="index" :index="index" :item="item"></feature-card>
            </template>
          </v-row>

          <v-row style="margin: 75px 0px 50px">
            <v-col cols="12" class="text-center">
              <financial-freedom></financial-freedom>
            </v-col>
          </v-row>

          <v-row style="margin: 75px 0px 50px">
            <v-col cols="12" class="text-center">
              <span class="h3">As easy as 1, 2, 3!</span>
            </v-col>
          </v-row>

          <v-row justify="center">
            <template v-for="(item, index) in instructions">
             <instruction-card :key="index" :item="item"></instruction-card>
            </template>
          </v-row>
        </section>

        <section id="fourth" style="margin: 150px 0">
          <live-tournaments> </live-tournaments>
        </section>
        <!-- <section style="margin:300px 0px">
          <v-row justify="center">
            <v-col cols="12" class="d-flex justify-center" style="position: absolute">
              <nft-card :cards="nfts"> </nft-card>
            </v-col>
          </v-row>
        </section> -->

        <section>
          <v-row class="sec5">
            <v-col cols="12">
              <v-row class="sec5">
                <v-col cols="12" md="5" sm="12" lg="6" xl="6" class="sec5-left">
                  <span class="sec5-left_title"
                    >eSports focused <br />NFT Marketplace</span
                  >
                  <div class="sec5-left_text">
                    <p>
                      Enjoy our eSports tailored marketplace with exclusive
                      virtual items from players and organizations around the
                      world.
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  sm="12"
                  lg="6"
                  xl="6"
                  class="sec5_right"
                >
                  <v-img
                    contain
                    :height="$vuetify.breakpoint.mobile ? 300 : 600"
                    :max-width="$vuetify.breakpoint.mobile ? 250 : 600"
                    :src="require('@/assets/img/nft.png')"
                    :lazy-src="require('@/assets/img/nft.png')"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>

        <section id="roadmap" style="margin: 0px 0px">
          <v-row align="center" justify="center" class="text-center mb-7">
            <v-col>
              <div class="h3">Roadmap</div>
            </v-col>
          </v-row>

          <v-row
            class="d-flex justify-center align-center"
            style="margin-bottom: 40px"
          >
            <div v-if="$vuetify.breakpoint.mdAndUp" class="divider-left" />
            <div
              v-for="(ph, index) in 3"
              :key="index"
              class="ma-2"
            >
              <div v-if="index > 2">
                <div class="road__disabled">
                  <span>202{{ index + 1 }}</span>
                </div>
              </div>
              <a
                v-else
                class=""
                style="text-decoration: none"
                @click="change(index)"
              >
                <div :class="[index == roadmap ? 'road road__active' : 'road']">
                  <span>202{{ index + 1 }}</span>
                </div>
              </a>
            </div>
            <div v-if="$vuetify.breakpoint.mdAndUp" class="divider-right" />
          </v-row>

          <v-container>
            <v-row justify="center">
              <v-col cols="12" class="px-0">
                <div class="swipers">
                  <roadmap :year="roadmap" />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </section>

        <v-row style="margin: 75px 0px 40px">
          <v-col cols="12" class="text-center">
            <token-break-down />
          </v-col>
        </v-row>

        <v-row style="margin: 75px 0px 40px">
          <v-col cols="12" class="text-center">
            <token-distribution />
          </v-col>
        </v-row>

        <section id="team" style="margin: 150px 0 0px">
          <v-row align="center" justify="center" class="d-flex text-center">
            <v-col>
              <div class="h3">Team</div>
            </v-col>
          </v-row>

          <v-row
            class="white--text justify-center"
            :style="$vuetify.breakpoint.mdAndUp ? 'margin: 0px 100px;' : ''"
          >
            <template v-for="(user, i) in team">
              <team-member-card :key="i" :user="user"></team-member-card>
            </template>
          </v-row>
        </section>

        <section id="team" style="margin: 150px 0 0px">
          <v-row align="center" justify="center" class="d-flex text-center">
            <v-col>
              <div class="h3">Advisors</div>
            </v-col>
          </v-row>

          <v-row id="partners"
            class="white--text justify-center"
            :style="$vuetify.breakpoint.mdAndUp ? 'margin: 0px 100px;' : ''"
          >
            <template v-for="(user, i) in advisors">
              <team-member-card :key="i" :user="user"></team-member-card>
            </template>
          </v-row>
        </section>

        <section style="margin-top: 180px">
          <div class="divdr1"></div>
          <v-row align="center" justify="center" class="d-flex text-center">
            <v-col class="pt-9">
              <div class="h2">Partners</div>
            </v-col>
          </v-row>

          <v-row justify="center" class="pt-5">
            <template v-for="(partner, index) in partners">
              <v-col
                class="d-flex justify-center align-center mx-5"
                cols="12"
                md="2"
                :key="index"
              >
                <v-tooltip bottom color="#000">
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="partner.website" target="_blank" rel="noopener">
                      <v-img
                        contain
                        v-bind="attrs"
                        v-on="on"
                        :height="partner.height"
                        :width="
                          $vuetify.breakpoint.mobile ? 200 : partner.width
                        "
                        :src="partner.src"
                      />
                    </a>
                  </template>
                  <span>{{ partner.name }}</span>
                </v-tooltip>
              </v-col>
            </template>
            <div class="divdr2 mt-9"></div>
          </v-row>
        </section>

        <section>
          <v-row>
            <v-col>
              <span class="footer"
                >Copyright © 2021 Good Game. All rights reserved.</span
              >
            </v-col>
          </v-row>
        </section>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import FeatureCard from "../components/FeatureCard.vue";
import InstructionCard from '../components/InstructionCard.vue';
import LiveTournaments from "../components/LiveTournaments.vue";
// import NftCard from '../components/NftCard.vue';
import Overview from "../components/Overview.vue";
import Roadmap from "../components/Roadmap.vue";
import SideBar from "../components/SideBar.vue";

import TeamMemberCard from "../components/TeamMemberCard.vue";
import TokenBreakDown from '../components/TokenBreakDown.vue';
import TokenDistribution from '../components/TokenDistribution.vue';
import FinancialFreedom from '../components/FinancialFreedom.vue';
import store from "../store";
export default {
  components: {
    SideBar,
    Roadmap,
    FeatureCard,
    LiveTournaments,
    TeamMemberCard,
    Overview,
    InstructionCard,
    TokenDistribution,
    TokenBreakDown,
    // NftCard,
    FinancialFreedom,
  },
  store: store,
  data() {
    return {
      roadmap: 0,
    };
  },
  methods: {
    change(item) {
      if (this.roadmap == item) {
        this.roadmap = null;
      } else {
        this.roadmap = item;
      }
    },
  },
  created() {
    this.nfts = store.state.nfts;
    this.team = store.state.team;
    this.advisors = store.state.advisors;
    this.games = store.state.games;
    this.features = store.state.features;
    this.instructions = store.state.instructions;
    this.partners = store.state.partners;
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Orbitron");
@import url("https://fonts.googleapis.com/css?family=Roboto");
@import "../assets/styles/Home.scss";
</style>

